export default "__VITE_ASSET__DN5guZ$y__"